import { useFormik } from 'formik';
import React, { useEffect } from 'react';
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { useAddAssignmentMutation, useEditAssignmentMutation } from '../../features/assignments/assignmentsApi';
import { toggleAssignmentModal } from '../../features/assignments/assignmentsSlice';
import { useGetVideosQuery } from '../../features/videos/videosApi';
import { customStyles } from '../../utils/constantVariables';


Modal.setAppElement('#root');

const validationSchema = Yup.object({
	title: Yup.string().required('Title is required'),
	video_id: Yup.number().required('Video is required'),
	totalMark: Yup.number().min(0).required('Total Mark is required'),
});


function AssignmentForm() {
	//Variables
	const { isAssignmentModalOpen, assignmentFormData } = useSelector((state) => state.assignments);
	const { id, title, video_id, totalMark } = assignmentFormData || {};
	const dispatch = useDispatch();
	const [addAssignment, { isSuccess: addSuccess, isError: addError, isLoading: editLoading }] = useAddAssignmentMutation();
	const [editAssignment, { isSuccess: editSuccess, isError: editError, isLoading: addLoading }] = useEditAssignmentMutation();
	const videosQuery = useGetVideosQuery();
	const videos = videosQuery.data ?? [];

	const initialValues = {
		title: title || '',
		video_id: video_id || '',
		totalMark: totalMark || 0,
	}

	//Hooks
	useEffect(() => {
		if (addSuccess || editSuccess) {
			dispatch(toggleAssignmentModal(false));
		}
	}, [addSuccess, editSuccess, dispatch])

	const { values, handleBlur, handleChange, handleSubmit, touched, errors } = useFormik({
		initialValues,
		validationSchema,
		onSubmit: async (values, { resetForm }) => {
			const payload = { ...values }
			payload.video_id = Number(payload.video_id);
			const { title } = videos.find(video => video.id === payload.video_id);
			payload.video_title = title;
			if (id) {
				editAssignment({ id: id, data: payload })
			} else {
				addAssignment({ data: payload });
			}
		},
	});

	//Functions
	const handleModal = () => {
		dispatch(toggleAssignmentModal(!isAssignmentModalOpen));
	}

	return (
		<div>
			<Modal
				isOpen={isAssignmentModalOpen}
				onRequestClose={handleModal}
				style={customStyles}
			>
				<form onSubmit={handleSubmit}>
					<div>
						<label htmlFor="name">Title:</label>
						<input
							type="text"
							id="title"
							name="title"
							onChange={handleChange}
							onBlur={handleBlur}
							value={values.title}
						/>
						{touched.title && errors.title ? (
							<div className='form-error'>{errors.title}</div>
						) : null}
					</div>
					<div>
						<label htmlFor="category">Video Title:</label>
						<select
							id="video_id"
							name="video_id"
							onChange={handleChange}
							onBlur={handleBlur}
							value={values.video_id}
							className="select-dropdown"
						>
							<option value="" disabled>
								Select category
							</option>
							{videos?.length > 0 && videos.map((video) => (
								<option key={video.id} value={video.id}>
									{video.title}
								</option>
							))}
						</select>
						{touched.video_id && errors.video_id ? (
							<div className='form-error'>{errors.video_id}</div>
						) : null}
					</div>
					<div>
						<label htmlFor="name">Total Mark:</label>
						<input
							type="number"
							id="totalMark"
							name="totalMark"
							onChange={handleChange}
							onBlur={handleBlur}
							value={values.totalMark}
						/>
						{touched.totalMark && errors.totalMark ? (
							<div className='form-error'>{errors.totalMark}</div>
						) : null}
					</div>

					<div className='form-footer'>
						<button type='close' onClick={handleModal}>
							Close
						</button>
						<button type='submit' disabled={addLoading || editLoading}>
							Submit
						</button>
					</div>

				</form>
			</Modal>

		</div>
	)
}

export default AssignmentForm